export const BACKGROUND_SOUND_AMBIENCE = "/music/background.mp3";
export const BACKGROUND_VIDEO_AMBIENCE_MP4 = "/videos/FOND_INTRO_OUTRO.mp4";
export const BACKGROUND_VIDEO_ENVIRONMENTAL_MP4 =
  "/videos/FOND_ENVIRONNEMENTAL.mp4";
export const BACKGROUND_VIDEO_LIFE_STYLE_MP4 = "/videos/FOND_LIFESTYLE.mp4";
export const BACKGROUND_VIDEO_HORMONAL_MP4 = "/videos/FOND_HORMONAL.mp4";
